<template>
  <d-container fluid class="main-content-container px-4 pb-4">
      <div class="container">
        <img class="ignite-logo" src="/prayer.admin/img/ignite.png">
        <div class="manage-account">
        <div class="" style="text-align:center">
          <d-row>
            <d-col md="12" class="form-group">
                <input class="rfid-box" id="rfid" name="rfid" v-model="rfid" autofocus type="text"  @keyup.enter="rsubmit" placeholder="Scan RFID" />
            </d-col>
          </d-row>
          <d-row>
            <d-col md="12">
            <div id=t1 class="ignite-result-1" v-if="first_time">
              Selamat mengikuti Persekutuan Doa Malam
            </div>
            <div id=ts1 class="ignite-result-1" v-if="signout">
              {{statement_1}}
            </div>
            </d-col>
          </d-row>
          <d-row>
            <d-col md="12">
            <div id=t2 class="ignite-result-2">
              {{data_str}}
            </div>
            <div id=tc class="ignite-result-3">
              ( Circle {{circle_str}} )
            </div>
            </d-col>
          </d-row>
          <d-row>
            <d-col md="12">
            <div id=t3 class="ignite-result-1" v-if="first_time">
            </div>
            <!--div id=t3 class="ignite-result-1" v-if="first_time">
silahkan hadir Jumat 5 September 2025
pk 20.00
            </div-->
            <div id=ts2 :class="s2_last_episode? 'ignite-s2-last' : 'ignite-result-1'" v-if="signout">
              {{statement_2}}
            </div>
            <div id=ts3 :class="s2_last_episode? 'ignite-s2-last' : 'ignite-result-1'" v-if="signout">
              {{statement_3}}
            </div>
            </d-col>
          </d-row>
          <d-row>
            <d-col md="12">
            <div id=t4 class="ignite-result-1" v-if="already_scanned">
Anda sudah absen hari ini
            </div>
            </d-col>
          </d-row>
          <d-row>
            <d-col md="12" class="form-group">
            <div style="min-height:30px;margin-top:5px;color:red;font-size:.8rem;">
              {{error_str}}
            </div>
            </d-col>
          </d-row>
        </div>
        </div>
      </div>
  </d-container>
</template>
<style>
#rfid:focus{
outline:none;
}
.ignite-s2-last{
font-size:4em;
color:#1589FF;
transition: opacity 2s ease;
opacity:0;
}
.ignite-result-1{
font-size:4em;
color:orange;
transition: opacity 2s ease;
opacity:0;
}
.ignite-result-2{
font-size:6em;
color:#c70;
text-transform: uppercase;
transition: opacity 2s ease;
opacity:0;
}
.ignite-result-3{
font-size:3em;
color:#c70;
text-transform: uppercase;
transition: opacity 2s ease;
opacity:0;
}
@keyframes fadeOut {
  from { opacity: 1; }
  to   { opacity: 0; }
}
.fade-out {
    animation: fadeOut 10s forwards;
}
.rfid-box {
    font-size: 12px;
    background: maroon !important;
    color: yellow;
    border: none !important;
    border-radius:0 !important;
    transition: all .3s ease-in-out;
    width:100%;
    position:fixed;
    top:0;
    left:0;
}

@keyframes logoAnimation {
    0% { filter: brightness(1); }
    100% { filter: brightness(2); }
}    

.ignite-logo {
    margin-top:.5em;
    width: 30vh;
    height: auto;
    animation: logoAnimation 1s ease infinite alternate;
}
</style>
<script>
import axios from 'axios';
import env from '../env.vue';

export default {
  data(){
    return{
      statement_1:'',
      statement_2:'',
      statement_3:'',
      rfid:'',
      error_str:'',
      data_str:'',
      circle_str:'',
      loading:false,
      id1:0,
      id2:0,
      id3:0,
      first_time:false,
      signout:false,
      already_scanned:false,
      s2_last_episode:false,  
    }
  },
  
  methods: {
	playAudio(filePath) {
	  const audio = new Audio(filePath);
      audio.playbackRate = 1;
	  audio.play();
	},
    rsubmit(e){
      e.preventDefault()
      this.error_str=''
      this.data_str=''
      this.circle_str=''
      this.loading=true
      axios.get(env.server+'/attendance/save/'+this.rfid, 
      {
      }
      ).then(resp => {
        this.loading=false;
        if (this.id1>0) { clearTimeout(this.id1); this.id1=0 }
        if (this.id2>0) { clearTimeout(this.id2); this.id2=0 }
        if (this.id3>0) { clearTimeout(this.id3); this.id3=0 }
        console.log('resp',resp.data);
        let adata = resp.data.data[0];
        this.data_str=adata.fullname;
        this.circle_str=adata.circle>0 ? adata.circle: 'belum ada';
        this.rfid='';
        this.already_scanned = adata.data=='-1' ? 1:0;
        this.first_time = adata.data!='' && !this.already_scanned  && adata.data.split(/,/).length==1 ? 1:0;
        this.first_time = true;
		const currentDate = new Date();
		const year = currentDate.getFullYear();
		const month = currentDate.getMonth() + 1; // Months are zero-based
		const day = currentDate.getDate();        
        if (year=='2025'&& month=='9'&&day=='6'){
          this.first_time=false;
          this.statement_1='Setelah mengalami doa semalaman, saya :'
          this.statement_2='rindu menjalani hidup yang berbeda, Never be the same!';
          this.signout=true;
        }
        if (year=='2026'&& month=='3'&&day=='30'){
          this.first_time=false;
            this.statement_1=''
            this.statement_2='7 DAYS of PRAYER';
            this.statement_3='HARI PERTAMA';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2026'&& month=='3'&&day=='31'){
          this.first_time=false;
            this.statement_1=''
            this.statement_2='7 DAYS of PRAYER';
            this.statement_3='HARI KEDUA';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2026'&& month=='4'&&day=='1'){
          this.first_time=false;
            this.statement_1=''
            this.statement_2='7 DAYS of PRAYER';
            this.statement_3='HARI KETIGA';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2026'&& month=='4'&&day=='2'){
          this.first_time=false;
            this.statement_1=''
            this.statement_2='7 DAYS of PRAYER';
            this.statement_3='HARI KEEMPAT';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2026'&& month=='4'&&day=='3'){
          this.first_time=false;
            this.statement_1=''
            this.statement_2='7 DAYS of PRAYER';
            this.statement_3='HARI KELIMA';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2026'&& month=='4'&&day=='4'){
          this.first_time=false;
            this.statement_1=''
            this.statement_2='7 DAYS of PRAYER';
            this.statement_3='HARI KEENAM';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2026'&& month=='4'&&day=='5'){
          this.first_time=false;
            this.statement_1=''
            this.statement_2='7 DAYS of PRAYER';
            this.statement_3='HARI KETUJUH';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2025'&& month=='12'&&day=='2'){
          this.first_time=false;
          this.statement_1='';
          if( adata.attendance_data.match(/2025-11-26/))
            this.statement_2='Magnet sudah diambil minggu lalu';
          else
            this.statement_2='';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2025'&& month=='12'&&day=='3'){
          this.first_time=false;
          this.statement_1='';
          if( adata.attendance_data.match(/2025-11-26/))
            this.statement_2='Magnet sudah diambil minggu lalu';
          else
            this.statement_2='';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2025'&& month=='12'&&day=='10'){
          this.first_time=false;
          this.statement_1='';
          if( adata.attendance_data.match(/2025-11-26/))
            this.statement_2='Magnet sudah diambil 2 minggu lalu';
          else if( adata.attendance_data.match(/2025-12-03/))
            this.statement_2='Magnet sudah diambil minggu lalu';
          else
            this.statement_2='';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2025'&& month=='12'&&day=='17'){
          this.first_time=false;
          this.statement_1='';
          if( adata.attendance_data.match(/2025-11-26/))
            this.statement_2='Magnet sudah diambil 3 minggu lalu';
          else if( adata.attendance_data.match(/2025-12-03/))
            this.statement_2='Magnet sudah diambil 2 minggu lalu';
          else if( adata.attendance_data.match(/2025-12-10/))
            this.statement_2='Magnet sudah diambil minggu lalu';
          else
            this.statement_2='';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2025'&& month=='12'&&day=='24'){
          this.first_time=false;
          this.statement_1='';
          if( adata.attendance_data.match(/2025-11-26/))
            this.statement_2='Magnet sudah diambil 4 minggu lalu';
          else if( adata.attendance_data.match(/2025-12-03/))
            this.statement_2='Magnet sudah diambil 3 minggu lalu';
          else if( adata.attendance_data.match(/2025-12-10/))
            this.statement_2='Magnet sudah diambil 2 minggu lalu';
          else if( adata.attendance_data.match(/2025-12-17/))
            this.statement_2='Magnet sudah diambil minggu lalu';
          else
            this.statement_2='';
          if (this.already_scanned) this.statement_1='Anda sudah absen hari ini'
          this.signout=true;
        }
        if (year=='2025'&& month=='11'&&day=='26'){
          this.first_time=false;
          this.s2_last_episode=true;
          this.statement_1='';
          this.statement_2='Tempelkan magnet ini, sebuah pengingat hidup anda berbeda';
//          this.statement_2='selamat mengikuti season two episode 12, Never be the same!';
          if (this.already_scanned) this.statement_2='Mohon maaf, magnet sudah diberikan saat tap pertama tadi'
          this.signout=true;
        }
        document.getElementById('t2').style.opacity='1';
        if (!this.signout){
			document.getElementById('tc').style.opacity='1';
			document.getElementById('tc').style.display='block';
			if (this.already_scanned){
			  this.playAudio('/prayer.admin/mp3/sudah_absen'+(Math.floor(Math.random() * 4) + 1)+'.mp3');
			  setTimeout( ()=>{
			  document.getElementById('t4').style.opacity='1';
			  },100)
			  this.id3=setTimeout( ()=>{
			  document.getElementById('t4').style.opacity='0';
			  },90000)
			}else if (!this.first_time)
			  this.playAudio('/prayer.admin/mp3/shalom'+(Math.floor(Math.random() * 4) + 1)+'.mp3');
			else{
			  this.playAudio('/prayer.admin/mp3/selamat_bergabung'+(Math.floor(Math.random() * 4) + 1)+'.mp3');
			  setTimeout( ()=>{
			  document.getElementById('t1').style.opacity='1';
			  document.getElementById('t3').style.opacity='1';
			  },100)
			  this.id1=setTimeout( ()=>{
			  document.getElementById('t1').style.opacity='0';
			  document.getElementById('t3').style.opacity='0';
			  },90000)
		    }
        } else {
			  this.playAudio('/prayer.admin/mp3/never'+(Math.floor(Math.random() * 4) + 1)+'.mp3');
			  document.getElementById('tc').style.display='none';
			  setTimeout( ()=>{
		  document.getElementById('ts1').style.opacity='1';
		  document.getElementById('ts2').style.opacity='1';
		  document.getElementById('ts3').style.opacity='1';
			  },100)
        }
        this.id2=setTimeout( ()=>{
        document.getElementById('t2').style.opacity='0';
        document.getElementById('tc').style.opacity='0';
        document.getElementById('ts1').style.opacity='0';
        document.getElementById('ts2').style.opacity='0';
        document.getElementById('ts3').style.opacity='0';
        },90000)
      }).catch( error => {
        this.loading=false;
        this.rfid='';
        if(error.response==undefined)return;
        console.log('err',error.response);
        if ( error.response.status=='404' ){
          this.playAudio('/prayer.admin/mp3/notfound'+(Math.floor(Math.random() * 4) + 1)+'.mp3');
          this.error_str='Invalid RFID';
          this.already_scanned=false;
          this.first_time=false;
        }
      });
    }
  },
  mounted(){
   document.getElementsByTagName('html')[0].style.overflow='hidden';
  }
};
</script>
